<section class="break-history" data-cy="break-history">
  <div class="bh-heading">History</div>

  <div *ngIf="isLoading" class="bh-loading" data-cy="history-loading">
    <span
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    Loading history…
  </div>

  <p *ngIf="!isLoading && hasError" class="bh-error" data-cy="history-error">
    Couldn't load history.
  </p>

  <p
    *ngIf="!isLoading && !hasError && history.length === 0"
    class="bh-empty"
    data-cy="history-empty"
  >
    No history yet.
  </p>

  <ol class="bh-timeline" *ngIf="visibleHistory.length > 0">
    <li
      class="bh-entry"
      data-cy="history-entry"
      *ngFor="let entry of visibleHistory"
    >
      <span class="bh-dot" [ngClass]="statusClass(entry.statusName)"></span>
      <div class="bh-content">
        <div class="bh-line">
          <span class="bh-actor" data-cy="history-actor">{{
            entry.userName
          }}</span>
          <span class="bh-verb">set status to</span>
          <span
            class="bh-badge"
            [ngClass]="statusClass(entry.statusName)"
            data-cy="history-status"
            >{{ statusLabel(entry.statusName) }}</span
          >
        </div>
        <div class="bh-meta">
          <span data-cy="history-timestamp">{{
            entry.dateTime | date: 'MMM d, y, h:mm a'
          }}</span>
          <span
            *ngIf="entry.expiration?.date"
            class="bh-expiry"
            data-cy="history-expiry"
            >· until {{ entry.expiration?.date | date: 'MMM d, y' }}</span
          >
        </div>
        <div
          class="bh-detail"
          *ngIf="hasDetail(entry)"
          data-cy="history-detail"
        >
          <div class="bh-detail-row" *ngIf="code(entry.descriptionCode)">
            <span class="bh-detail-label">Description</span>
            <span data-cy="history-description">{{
              code(entry.descriptionCode)
            }}</span>
          </div>
          <div class="bh-detail-row" *ngIf="code(entry.actionCode)">
            <span class="bh-detail-label">Action</span>
            <span data-cy="history-action">{{ code(entry.actionCode) }}</span>
          </div>
          <div class="bh-detail-row" *ngIf="code(entry.note)">
            <span class="bh-detail-label">Note</span>
            <span data-cy="history-note">{{ entry.note }}</span>
          </div>
          <div class="bh-detail-row" *ngIf="code(entry.researchNote)">
            <span class="bh-detail-label">Research</span>
            <span data-cy="history-research">{{ entry.researchNote }}</span>
          </div>
        </div>
      </div>
    </li>
  </ol>

  <button
    *ngIf="hasMore"
    type="button"
    class="bh-more-btn"
    data-cy="toggle-expand"
    (click)="toggleExpanded()"
  >
    {{ expanded ? 'Show less' : 'Show ' + hiddenCount + ' more' }}
  </button>
</section>
